<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #cabecalho>
        <div class="modal-title w-75 mx-auto">
          <div class="d-flex justify-content-center ">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-0">
              <h5 class="textos text-center text-bold">
                Aceite de contrato
              </h5>
              <h6 class="text-center mt-4">
                <span class="textos">Por favor leia os contratos referente aos termos de privacidade e de uso do produto.
                  <strong>Seu aceite é necessário para dar continuidade ao uso do produto.</strong>
                </span>
              </h6>
            </div>
          </div>
        </div>
      </template>
      <template #corpo>
        <form class="mt-3 aceite-contrato w-75 mx-auto">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <template v-if="representanteLegal">
            <Endereco
            :listaDeErros="retorno.listaDeErros"
            v-model="formulario.endereco"
            :flagsDeControle="flagsDeControle"
            :consultaUnidadesFederativas="obterUnidadesFederativas"
            />
          </template>
          <div class="form-row justify-content-center">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form-group">
              <a href="/pdf/Politica_de_Privacidade_Mirt.pdf" target="_blank">Política de privacidade</a><br />
              <label for="inputAceitePrivacidade" class="labelContrato small text-wrap">Concordo com os termos de privacidade:</label>
              <input type="checkbox" v-model="formulario.aceite_privacidade" :disabled="desabilitarCampos" class="custom-control-input checkBoxContrato" id="inputAceitePrivacidade">
              <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.aceite_privacidade}}</div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form-group">
              <a href="/pdf/Termos_de_Uso_Mirt.pdf" target="_blank">Termos de uso</a><br />
              <label for="inputAceiteContrato" class="labelContrato small text-wrap">Concordo com os termos de uso do produto:</label>
              <input type="checkbox" v-model="formulario.aceite_contrato" :disabled="desabilitarCampos" class="custom-control-input checkBoxContrato" id="inputAceiteContrato">
              <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.aceite_contrato}}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button class="btn btn-verde btn-block col-xl-12 col-lg-12 col-md-12 col-sm-12" variant="outline-success" :disabled="desabilitarCampos" @click="salvarDadosDeAceite()">Confirmar</b-button>
          </div>
          <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex justify-content-center align-items-center">
            <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
        </form>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import AceiteContrato from './js/aceiteContrato'
export default AceiteContrato
</script>

<style scoped>
@import "./scss/aceiteContrato.scss";
</style>
